/*global ViewController, WebView, $*/

var genInfoPopupController = new ViewController(
    {
        directory: "modules/bill/views/bill",
        name: "genInfoPopup",
        route: "gen-info-popup",
        buttonsHTML: "<!-- no button -->",
        openInPopup: true,
        noTitle: true,
        defaultData: { },
        popup: {
            size: "medium"
        }
    }
);

genInfoPopupController.prepareDataOnEnter = function(data, callback){
    this.api.db.multiread({
        iz_template_task: {
            searchFirst:{ id: data },
            joinFetch: [
                { otherTable: "iz_sign", name: "sign", type: "2many", thisField: "res_id", otherField: "res_id" , joins: [
                    { otherTable: "iz_sign_signer", name: "signers", type: "2many" }
                ]}
            ]
        }
    }, function(err, reads){
        if(err){ return callback(err) ; }
        var record = {} ;
        record.iz_template_task = reads.iz_template_task || {} ;
        
        record.signatures= [] ;
        record.iz_template_task.sign.forEach( function(sign){
            if(sign.res_model === record.iz_template_task.res_model){
                record.signatures = sign.signers;
            }
        }) ;

        return callback(null, record) ;
    }.bind(this)) ;
} ;


genInfoPopupController.onDownloadSign = function(ev){
    var sign = ev.data.data ;
    this.api.sign.downloadSignature(sign.sign_id, function(){}) ;
} ;

genInfoPopupController.onCancelSign = function(ev){
    var sign = ev.data.data ;
    this.view.longTask(function(done){
          this.api.db.transactionalChanges([{
              table: "iz_sign_signer",
              action: "update",
              record: {
                  id: sign.id,
                  state: "cancel"
              }
          }], function(err){
            if(err){ return done(err) ;}
            this.refresh(done) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


module.exports = genInfoPopupController ;
